import {PipelineGraph, PipelineGraphEntity} from "../../../model/pipeline/pipeline-graph";
import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type PipelineGraphSelectorProps = {
    pipelineId?: string
};

const getPipelineIdParam = createParamSelector<PipelineGraphSelectorProps | undefined, string | undefined>(params => params?.pipelineId);

export const pipelineGraphsSelector = () => createSelector(
    [getUseQueryResultData<PipelineGraph[]>, getPipelineIdParam],
    (data, pipelineId) => {
        return selectPipelineGraphsAndTransform(
            data ?? [], {
                pipelineId: pipelineId,
            }
        );
    }
);

export const pipelineGraphSelector = () => createSelector(
    [getUseQueryResultData<PipelineGraph>],
    (data) => {
        return data ? transformPipelineGraph(data) : undefined;
    }
);

export const selectPipelineGraphs = (values?: PipelineGraph[], selector?: PipelineGraphSelectorProps): PipelineGraph[] => {
    if (!values) {
        return [];
    }

    return values.filter((v) => {
        let filterIn = true;

        if (selector?.pipelineId) {
            if (v.pipelineId !== selector.pipelineId) {
                filterIn = false;
            }
        }

        return filterIn;
    });
};

export const transformPipelineGraph = (value: PipelineGraph): PipelineGraphEntity => {
    return PipelineGraphEntity.from(value)
}

export const selectPipelineGraphsAndTransform = (values?: PipelineGraph[], selector?: PipelineGraphSelectorProps): PipelineGraphEntity[] => {
    const selected = selectPipelineGraphs(values, selector);
    return selected.map(transformPipelineGraph);
};
